import {
  messageId,
  PropertyMeta,
  ValueObjectMetaString,
} from "@pscsrvlab/psc-react-components";
import { z } from "zod";
const minimalSchema = z.string().max(100);
const savedMinimalSchema = z.string().max(100);
const schema = z.string().min(1).max(100);
const savedSchema = z.string().min(1).max(100);
const jsonSchema = z.string();
/**
 * 電話番号(値オブジェクト)のメタデータ。
 *
 *  */
export const phoneNumberMeta = new ValueObjectMetaString(
  "PhoneNumber",
  "\u96FB\u8A71\u756A\u53F7",
  messageId("lbl.\u96FB\u8A71\u756A\u53F7"),
  minimalSchema,
  schema,
  jsonSchema,
  undefined,
  undefined
);
